import { message } from '@linktivity/link-ui';
import { StationMixer } from '@linktivity/sagano';
import { auth } from '@sagano/station/stores';

const BASE_PATH = import.meta.env.VITE_API_STATION_HOST;

const config = new StationMixer.Configuration({
  basePath: BASE_PATH,
  middleware: [
    {
      pre: async context => {
        const requestHeaders: HeadersInit = new Headers({
          'Content-Type': 'application/json'
        });
        requestHeaders.append(
          'grpc-metadata-auth-token',
          await auth.getRefreshedToken()
        );
        context.init.headers = requestHeaders;
      },
      post: async context => {
        if (!context.response.ok) {
          // handle error
          const data = await context.response.json();
          message.error(
            data.common.error_description || data.common.error_code,
            10
          );
        }
      }
    }
  ]
});

export default config;
